import { render, staticRenderFns } from "./AddProofDoc.vue?vue&type=template&id=b6961240&scoped=true&"
import script from "./AddProofDoc.vue?vue&type=script&lang=js&"
export * from "./AddProofDoc.vue?vue&type=script&lang=js&"
import style0 from "./AddProofDoc.vue?vue&type=style&index=0&id=b6961240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6961240",
  null
  
)

export default component.exports